// Offers saved or shared with the djb2 legacy ID (before the server-side offerId existed) still match.
export function isSameOffer(item, offerId) {
  return Boolean(offerId) && (offerId === item.id || offerId === item.legacyId);
}
